<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="p5"></a><span epub:type="pagebreak" id="page5" title="5">CONTENTS</span></h2>
<p class="toc1"><a href="#/xhtml/fm01">Introduction</a></p>
<p class="toc"><a href="#/xhtml/chapter01"><strong>Curing</strong></a></p>
<p class="toc"><span href="#/xhtml/chapter02" title="Link target outside of Sample"><strong>Air drying</strong></span></p>
<p class="toc"><span href="#/xhtml/chapter03" title="Link target outside of Sample"><strong>Smoking</strong></span></p>
<p class="toc1"><span href="#/xhtml/chapter04" title="Link target outside of Sample"><strong>Recipes</strong></span></p>
<p class="tocs"><span href="#/xhtml/bm01" title="Link target outside of Sample">Suppliers</span></p>
<p class="tocs1"><span href="#/xhtml/bm02" title="Link target outside of Sample">Index</span></p>
<p class="imagex"><img alt="illustration" src="images/f0005-01.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?6606d845